import api from '../token';

export const ListImpostoid = async (dados) => {
  try {
    const response = await api.post('/getImpostoId', dados);
    return response.data;
  } catch (error) {
    
    return { success: false, message: error.message };
  }
};



